import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import api from '../api';
import { PROBE_FETCH_TIMEOUT_MS } from '../constants';
import { QueryKey } from '../enums';

export type BlobBrowserConnectivityDto = {
  url: string;
};

export const fetchBrowserConnectivityProbeUrl = async (): Promise<string> => {
  const data =
    await api.blobHealthCheck.blobHealthCheckControllerBrowserConnectivity({
      format: 'json',
    });

  return data.url;
};

export const probeBlobStorageUrl = async (url: string) => {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(
    () => controller.abort(),
    PROBE_FETCH_TIMEOUT_MS
  );
  try {
    const response = await fetch(url, {
      method: 'GET',
      cache: 'no-store',
      signal: controller.signal,
    });

    return response.ok;
  } finally {
    window.clearTimeout(timeoutId);
  }
};

export const checkBrowserBlobConnectivity = async () => {
  const url = await fetchBrowserConnectivityProbeUrl();

  return await probeBlobStorageUrl(url);
};

export const useBrowserBlobConnectivityQuery = (
  options?: Omit<UseQueryOptions<boolean, Error>, 'queryKey' | 'queryFn'>
) =>
  useQuery({
    ...options,
    queryKey: [QueryKey.Resource.BlobHealthCheck],
    gcTime: 0,
    retry: false,
    queryFn: () => checkBrowserBlobConnectivity(),
  });
